import {useEffect, useMemo} from "react";

type Environment = 'Local' | 'Development' | 'Staging' | 'Production';

export type GoogleAnalyticsConfiguration = {
    Id: string
    Options?: {
        gtm_auth?: string,
        gtm_preview?: string,
        gtm_cookies_win?: string
    }
}

type HostConfiguration = {
    environment: Environment,
    googleAnalytics?: GoogleAnalyticsConfiguration
}

const configurations: Record<string, HostConfiguration> = {
    'nobelreturns.dev.platform.dental': {
        environment: 'Development'
    },
    'nobelreturns.sta.platform.dental': {
        environment: 'Staging',
        googleAnalytics: {
            Id: 'GTM-P8QT3949',
            Options: {
                gtm_auth: 'LRfAHcJVnfLqv0OaKp6Cog',
                gtm_preview: 'env-3',
                gtm_cookies_win: 'x'
            }
        }
    },
    'nobelreturns.nobelbiocare.com': {
        environment: 'Production',
        googleAnalytics: {
            Id: 'GTM-P8QT3949',
        }
    },
    'localhost': {
        environment: 'Local'
    },
}

const GoogleAnalytics: React.FC = ({children}) => {
    const {googleAnalytics} = useMemo(() => configurations[window.location.host.split(':')[0]] || {}, [])
    
    console.log('google', googleAnalytics, window.location.host.split(':')[0])

    useEffect(() => {
        if (googleAnalytics) {
            const options = Object.keys(googleAnalytics.Options || {})
                // @ts-ignore
                .map(k => `${k}=${googleAnalytics.Options[k]}`)
                .join('&')
            const script = document.createElement('script')
            script.textContent = `
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl${options ? `+'&${options}'` : ''};f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${googleAnalytics.Id}');
            `
            document.head.prepend(script)

            const noscript = document.createElement('noscript')
            const iframe = document.createElement('iframe')
            iframe.src = `https://www.googletagmanager.com/ns.html?id=${googleAnalytics.Id}${options ? `&${options}` : ''}`
            iframe.height = '0'
            iframe.width = '0'
            iframe.setAttribute('style', 'display:none;visibility:hidden')
            noscript.appendChild(iframe)
            document.body.prepend(noscript)
        }
    }, [googleAnalytics])

    return <>{children}</>;
}

export default GoogleAnalytics
